import { render } from "./ImmersionDatesComponent.vue?vue&type=template&id=5d1ee1d8&scoped=true&ts=true"
import script from "./ImmersionDatesComponent.vue?vue&type=script&lang=ts"
export * from "./ImmersionDatesComponent.vue?vue&type=script&lang=ts"

import "./ImmersionDatesComponent.vue?vue&type=style&index=0&id=5d1ee1d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1ee1d8"]])

export default __exports__